export const SET_EDIT_MENU_ITEMS = 'setEditMenuItems'
export const SET_MASS_TEXT_ICON_DISABLED = 'setMassTextIconDisabled'
export const SET_MASS_TEXT_TOGGLE_DISABLED = 'setMassTextToggleDisabled'
export const SET_NOTIFICATION_VALUE = 'setNotificationValue'
